import { useNavigate } from "react-router-dom";
import { useState, useMemo } from "react";
import { DatePicker } from "rsuite";
import AppointmentHistoryTable from "./AppointmentHistoryTable";
import { Panel, PanelGroup, Placeholder } from "rsuite";
import Offcanvas from "react-bootstrap/Offcanvas";
import AppointmentHistoryGrid from "./AppointmentHistoryGrid";

function AppointmentHistory() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [viewType, setViewType] = useState("List");
  const navigate = useNavigate();

  const styleaccordion = `

  .rs-panel-group-bordered {
    border: none;
  }

  .rs-panel-group {
    border-radius: none;
    overflow: hidden;
  }

  .rs-panel-btn:active, .rs-panel-btn:focus, .rs-panel-btn:hover{
    background-color: none !important;
  }

  .rs-panel:last-child {
    border-bottom: none !important;
  }

  .rs-panel-btn:active, .rs-panel-btn:focus, .rs-panel-btn:hover {
    background-color: #fff !important;
    color: #343434;
    color: var(--rs-btn-subtle-hover-text);
    outline: 2px solid transparent;
}

.rs-panel-title {
    -ms-flex: 1 1 0%;
    flex: 1 1;
    margin: 0;
    text-align: left;
    font-weight: 500 !important;
    color: #000;
}

.rs-panel-collapsible>.rs-panel-header {
    cursor: pointer;
    padding: 3px;
    position: relative;
    -webkit-transition: background-color .3s linear, border-radius .3s linear;
    transition: background-color .3s linear, border-radius .3s linear;
}

.offcanvas-body {
    flex-grow: 1;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    overflow-y: auto;
    padding: 0px;
}
  
  `;

  return (
    <>
      <style>{styleaccordion}</style>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex justify-content-between"
          >
            <div className="d-flex">
              <h5 className="m-0 p-3">Appointments History</h5>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3">
              <div className="d-flex align-items-center gap-3">

                <button
                  style={{ background: "none" }}
                  className="border-0"
                  type="button"
                  onClick={() => setViewType("List")}
                >
                  {/* <img src="/images/filter.png" alt="" /> */}
                  <i class="fa-solid fa-rectangle-list"></i>
                </button>
                <button
                  style={{ background: "none" }}
                  className="border-0"
                  type="button"
                  onClick={() => setViewType("Grid")}
                >
                  <i class="fa-solid fa-border-all"></i>
                  {/* <img src="/images/Grid.png" alt="" /> */}
                </button>

                <button
                  onClick={handleShow}
                  type="button"
                  style={{
                    background: "#FAFFFB",
                    padding: ".3rem .6rem",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  }}
                  className="rounded-1"
                >
                  <img
                    style={{ width: "1rem" }}
                    src="/Images/filter123.svg"
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        {viewType === "List" && (
          <div className="row">
            <div className="col-12 p-0">
              <AppointmentHistoryTable />
            </div>
          </div>
        )}

        {viewType === "Grid" && (
          <div className="row">
            <div className="col-12 p-0">
              <AppointmentHistoryGrid />
            </div>
          </div>
        )}

        <Offcanvas
          show={show}
          onHide={handleClose}
          placement={"end"}
          style={{
            width: "22rem",
            margin: ".5rem .5rem",
            borderRadius: "0.5rem 0rem 0px .5rem",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              className="text-black"
              style={{ fontSize: "18px" }}
            >
              Filters
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="">
              <PanelGroup accordion className="no-border">
                <Panel header="Appointment Date">
                  <div className="d-flex align-items-center gap-2">
                    <input type="date" className="form-control" />
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Prescription Issued">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Yes</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>No</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Reason for Visit">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>In-person</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Virtual</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Emergency</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Walk-in</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Home Visit</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Telehealth</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Consultation</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Second Opinion</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Follow-up Visit</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Follow-Up Required">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Yes</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>No </span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Consultation Notes ">
                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>With Notes </span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Without Notes </span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Patient Name">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>
                </Panel>
              </PanelGroup>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </main>
    </>
  );
}

export default AppointmentHistory;
